import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Overlay } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';

class HorizontalMenuPopup extends Component {
	render() {
		const { target, show, onHide } = this.props;

		return <Overlay
			show={show}
			onHide={onHide}
			placement='bottom'
			rootClose
			target={() => ReactDOM.findDOMNode(target)}
			onClick={event => event.stopPropagation()}
		>
			<div
				style={{
					position: 'absolute',
					zIndex: 2000,
					backgroundColor: '#FFF',
					border: '1px solid #CCC',
					borderBottomLeftRadius: 4,
					borderBottomRightRadius: 4,
					padding: 5,
					maxWidth: 500
				}}>
				{this.props.children}
			</div>
		</Overlay>;
	}
}

export default withRouter(withTranslation()(HorizontalMenuPopup));